import React from 'react'

const siteShortNameMap = {
  themeforest: 'tf',
  codecanyon: 'cc',
  videohive: 'vh',
  audiojungle: 'aj',
  graphicriver: 'gr',
  photodune: 'pd',
  '3docean': '3d'
}

const redirectUrl = (site) => {
  return `https://elements.envato.com/all-items/?utm_campaign=elements_mkt-search_26JUNE2017&amp;utm_content=${siteShortNameMap[site]}_search-results&amp;utm_medium=promos&amp;utm_source=${site}.net`
}

const ElementsBanner = ({ currentSite }) => (
  <div className='elements-promo fds-u-mb4'>
    <div className='elements-promo__copy-wrapper'>
      <div className='elements-promo__content'>
        <a className='elements-promo__logo-white' href={redirectUrl(currentSite)}>Envato Elements</a>
        <h2 className='elements-heading fds-c-text-heading -size-l fds-u-mb0'>Deliver better projects faster</h2>
        <p className='elements-heading fds-c-text-body fds-u-mb0'>Unlimited photos, web templates, graphic assets &amp; courses.</p>
        <div className='elements-promo__button-wrapper'>
          <a className='elements-promo__button' href={redirectUrl(currentSite)}>View all</a>
        </div>
      </div>
    </div>
  </div>
)

export default ElementsBanner



// WEBPACK FOOTER //
// ./client/components/banners/elementsBanner.js